module.exports = __webpack_public_path__ + "img/travel.055a4bb.webp";